<template>
    <div class="disease-graph">
        <div class="page-cont">
            <h2 class="page-tit">中医药知识图谱 · 疾病画像</h2>
            <div class="disease-search">
                <el-input
                    class="search-input"
                    v-model.trim="searchWord"
                    placeholder="请输入疾病名称"
                    clearable
                    :disabled="searchLoading"
                    @keyup.enter.native="search_click"
                ></el-input>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    :loading="searchLoading"
                    @click="search_click"
                >查询</el-button>
            </div>

            <div class="graph-tabs" v-loading="searchLoading">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="医生模块" name="doctor" lazy>
                        <disease-doctor v-if="activeName === 'doctor'" />
                    </el-tab-pane>
                    <el-tab-pane label="科研模块" name="research" lazy>
                        <disease-research v-if="activeName === 'research'" />
                    </el-tab-pane>
                    <el-tab-pane label="科普模块" name="science" lazy>
                        <!-- <disease-science v-if="activeName === 'science'" /> -->
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseScience from './disease_science.vue';
import DiseaseResearch from './disease_research.vue';
import DiseaseDoctor from './disease_doctor.vue';

const TAB_NAMES = ['doctor', 'research', 'science'];

export default {
    name: 'DiseaseGraph',
    components: {
        DiseaseDoctor,
        DiseaseResearch,
        DiseaseScience,
    },
    data() {
        const tab = this.$route.query.tab;
        return {
            searchWord: this.$route.query.word || '',
            activeName: TAB_NAMES.includes(tab) ? tab : 'doctor',
            searchLoading: false,
        };
    },
    watch: {
        '$route.query.word'(val) {
            this.searchWord = val || '';
        },
        '$route.query.tab'(val) {
            if (TAB_NAMES.includes(val)) {
                this.activeName = val;
            }
        },
    },
    methods: {
        async search_click() {
            if (this.searchLoading) return;
            if (!this.searchWord) {
                this.$message.warning('请输入检索内容～');
                return;
            }
            const wordReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
            if (!wordReg.test(this.searchWord)) {
                this.$message.warning('请输入正确的检索词！');
                return;
            }
            this.searchLoading = true;
            try {
                await this.$router.replace({
                    path: '/diseaseGraph',
                    query: {
                        word: this.searchWord,
                        tab: this.activeName,
                    },
                });
                await this.$nextTick();
            } finally {
                this.searchLoading = false;
            }
        },
        handleClick(tab) {
            this.$router.replace({
                path: '/diseaseGraph',
                query: {
                    ...this.$route.query,
                    tab: tab.name,
                },
            });
            // tab 切换后触发一次 resize，兜底修正图表尺寸
            this.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });
        },
    },
};
</script>

<style lang="less" scoped>
.disease-graph {
    min-height: 520px;
    background: #F5F9FF;
    padding: 20px 0 60px;

    .page-tit {
        margin: 0 0 32px;
        font-size: 28px;
        font-weight: bold;
        color: #0C55AA;
        text-align: center;
    }

    .disease-search {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 28px;

        .search-input {
            width: 640px;
            margin-right: 16px;
        }

        ::v-deep .el-input__inner {
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            border-color: #C6DEFF;
        }

        .el-button {
            height: 44px;
            padding: 0 24px;
            background: #165DFF;
            border-color: #165DFF;
            border-radius: 8px;
        }
    }

    .graph-tabs {
        background: #fff;
        padding: 16px 20px 24px;
        border-radius: 10px;
        box-shadow: 0 4px 16px rgba(56, 109, 232, 0.08);

        ::v-deep .el-tabs__item {
            font-size: 16px;
            height: 44px;
            line-height: 44px;
        }

        ::v-deep .el-tabs__item.is-active {
            color: #165DFF;
            font-weight: bold;
        }

        ::v-deep .el-tabs__active-bar {
            background-color: #165DFF;
        }

        ::v-deep .el-tabs__nav-wrap::after {
            background-color: #E8EEF8;
        }
    }
}
</style>
